import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

export const StatsGrid = styled(Box)<{ isXs: boolean; columns: number }>`
  display: grid;
  gap: 24px;
  grid-template-columns: ${({ isXs, columns }) =>
    isXs ? '1fr' : `repeat(${columns}, 1fr)`};
`;
